var _path, _path2, _path3, _path4, _path5, _path6, _rect, _polygon, _polygon2, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperienceBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#333333",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,53a2,2,0,0,0-2,2h4A2,2,0,0,0,20,53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,49a2,2,0,0,0-2,2h4A2,2,0,0,0,24,49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40,49a2,2,0,0,0-2,2h4A2,2,0,0,0,40,49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8,62H56A24,24,0,0,0,8,62Zm21-7.04449A3.04445,3.04445,0,0,1,25.95557,58H17.0235a3.00173,3.00173,0,0,1-3.02008-2.83289,4,4,0,0,1,4.02826-4.167v-.00024A3.96846,3.96846,0,0,1,22,47v-.30194a3.6336,3.6336,0,0,1,3.31177-3.69312A3.5002,3.5002,0,0,1,29,46.5ZM35,46.5a3.5002,3.5002,0,0,1,3.68823-3.49506A3.6336,3.6336,0,0,1,42,46.69806V47a3.96846,3.96846,0,0,1,3.96832,3.99988v.00024a4,4,0,0,1,4.02826,4.167A3.00173,3.00173,0,0,1,46.9765,58H38.04443A3.04445,3.04445,0,0,1,35,54.95551Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46,56a2,2,0,0,0-4,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7,4a3,3,0,0,1,0,6,1,1,0,0,0-1,1v5H8V11.89941A5.00019,5.00019,0,1,0,2,7H4A3.00328,3.00328,0,0,1,7,4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 6,
    y: 18
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "51 17 41 13 41 27 51 31 51 17"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "52 31 62 27 62 13 52 17 52 31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71332,35.3916A4.28544,4.28544,0,0,0,10.05975,37H21V25H8v7H4ZM18,33.5H15v-1h3Zm-7-5h7v1H11Zm0,4h2v1H11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4a5.99672,5.99672,0,0,0-1,11.91V24h2V15.91A5.99672,5.99672,0,0,0,30,4Zm0,3.5A2.50294,2.50294,0,0,0,27.5,10h-1A3.50424,3.50424,0,0,1,30,6.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceBlack);
export default __webpack_public_path__ + "static/media/experienceBlack.d48f79aed546668ab648359338bf86bf.svg";
export { ForwardRef as ReactComponent };